import { Calendar, getCalculatedFolderId } from 'owa-calendar-cache';
import type { CalendarEntry, LinkedCalendarEntry, LocalCalendarEntry } from 'owa-graph-schema';
import { MailboxInfo, getUserMailboxInfo } from 'owa-client-ids';

export function convertToCalendarType(
    cacheCalendarEntry: CalendarEntry | LocalCalendarEntry | LinkedCalendarEntry,
    userMailboxInfo?: MailboxInfo
): Calendar {
    let calcFolderId = getCalculatedFolderId(cacheCalendarEntry).Id;
    if (!userMailboxInfo) {
        userMailboxInfo = getUserMailboxInfo();
    }

    return {
        id: {
            id: cacheCalendarEntry.calendarId.id,
            changeKey: cacheCalendarEntry.calendarId.changeKey,
            mailboxInfo: userMailboxInfo,
        },
        calculatedFolderId: calcFolderId,
        displayName: cacheCalendarEntry.CalendarName,
        colorScheme: null,
    };
}
